import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { TASK_BUCKET } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const getTaskBucketGroupList = async (data = array()) => {
  try {
    const response = await GET(TASK_BUCKET.GET_TASK_BUCKET_GROUP_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getTaskBucketList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${TASK_BUCKET.GET_TASK_BUCKET_LIST}/${data?._Id}`
      : `${TASK_BUCKET.GET_TASK_BUCKET_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addTaskBucket = async (data = array()) => {
  try {
    const response = await POST(TASK_BUCKET.ADD_TASK_BUCKET, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateTaskBucket = async (id, data = array()) => {
  try {
    const url = `${TASK_BUCKET.ADD_TASK_BUCKET}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getTaskBucketDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${TASK_BUCKET.GET_TASK_BUCKET_LIST}/${data?.Id}`
      : `${TASK_BUCKET.GET_TASK_BUCKET_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchTaskBucketTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${TASK_BUCKET.GET_TASK_BUCKET_SCHEMA}/${data?._Id}`
      : `${TASK_BUCKET.GET_TASK_BUCKET_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitTaskBucketFilterData = async (data = array()) => {
  try {
    const response = await POST(TASK_BUCKET.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/**
 * Build react-select options from filter/list POST body: each row may include
 * `users: [{ id, name }, …]`. Value = `id`, label = `name`.
 */
export const mapTaskBucketFilterUsersToSelectOptions = (payload) => {
  const raw = payload?.data ?? payload;
  const list = Array.isArray(raw) ? raw : raw?.records ?? raw?.rows ?? [];
  const byId = new Map();

  (Array.isArray(list) ? list : []).forEach((row) => {
    const arr = row?.users;
    if (!Array.isArray(arr)) return;
    arr.forEach((u) => {
      const idRaw = u?.id ?? u?._id ?? u?.userId ?? u?.user_id;
      const id = idRaw != null ? String(idRaw).trim() : "";
      if (!id || byId.has(id)) return;
      const label =
        String(u?.name ?? u?.userName ?? u?.fullName ?? u?.Name ?? "").trim() ||
        id;
      byId.set(id, { value: id, label });
    });
  });

  return Array.from(byId.values()).sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
  );
};
